module.exports = __webpack_public_path__ + "static/media/background-2.57642756.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppPages/images/background-2.jpg
// module id = 480
// module chunks = 0